import { ToggleButtonGroup, ToggleButton, Box, Stack } from '@mui/material';
import { AppDispatch, RootState } from 'packages/blu-booking/src/store';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserCalendarSetView } from '../store';
import { PulsanteVisualizzazione } from '../../../UI/Visualizzazione/PulsanteVisualizzazione';

export const Header = memo(function Header(): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();
  const { view, selectedPointOfSale } = useSelector(
    (state: RootState) => state.bluBookingUserCalendar
  );
  const filtersLoad = useSelector(
    (state: RootState) => state.bluBookingCalendarFilters.filtersLoad
  );

  return (
    // Container con nome: il pulsante Visualizzazione resta con la sola icona
    // quando la barra è stretta
    <Box
      sx={{
        height: '38px',
        display: 'flex',
        alignItems: 'center',
        m: '2px 4px 6px 4px',
        containerType: 'inline-size',
        containerName: 'bb-barra-giornaliero',
      }}
    >
      <Stack
        flexDirection="row"
        alignItems="center"
        sx={{ width: '100%' }}
        gap="20px"
      >
        <div style={{ flex: 1 }} />
        <ToggleButtonGroup
          exclusive
          value={view}
          onChange={(_, viewType) => {
            if (!viewType) return;
            dispatch(UserCalendarSetView(viewType));
          }}
        >
          <ToggleButton size="small" value="Day">
            Verticale
          </ToggleButton>
          <ToggleButton size="small" value="TimelineDay">
            Orizzontale
          </ToggleButton>
        </ToggleButtonGroup>
        {/* Niente fascia Presenze; senza punto vendita non ci sono orari, e
            il pulsante non c'è. Finché i filtri si caricano il punto vendita
            non è ancora scelto: il pulsante c'è, disabilitato, così le viste
            non si spostano */}
        <PulsanteVisualizzazione
          calendario="utente"
          view={view}
          conPresenze={false}
          conOre={!!selectedPointOfSale}
          disabilitato={!filtersLoad}
        />
      </Stack>
    </Box>
  );
});
